/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableERP } from "@finanedi.es/storybook"
import { useQuery } from "@tanstack/react-query"
import { getAsientoContableModelo115 } from "api/AsientoContable.service"
import { PERIODO } from "api/Types/Periodo"
import { Dropdown } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { HandleTabs } from "../../DetalleImpuestos"
import { RedirectParams } from "../constants"
import { MODELO_115_COLUMNS } from "./Modelo115Columns"

export const Modelo115 = ({
  props: { year, handleYearSelection, yearsOptionList },
}: {
  props: HandleTabs
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigate = ({ route, periodo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      year,
    })
  }
  const fetchModelo115 = async () => {
    const data = await getAsientoContableModelo115({
      Anyo: year.selectedYear,
      Periodo: PERIODO.TRIMESTRAL,
    })
    return data
  }

  const { data, isLoading } = useQuery({
    queryKey: ["modelo115", year.selectedYear],
    queryFn: fetchModelo115,
    select: (response) => {
      const periodos = response?.periodos ?? []
      return [
        ...periodos,
        {
          periodo: undefined,
          importe: periodos.reduce((acc, curr) => acc + (curr.importe ?? 0), 0),
        },
      ]
    },
    refetchOnWindowFocus: true,
  })

  return (
    <>
      <div className='tw-py-4'>
        <div className='tw-rounded-t-xl tw-flex tw-bg-simple-10 tw-justify-between tw-items-center '>
          <p className='tw-py-5 tw-pl-6 tw-m-0 tw-text-lg tw-font-medium'>
            {t("taxSummary.tableTitle115")}
          </p>
          <Dropdown
            id='rangosFechaIvaImpuesto'
            name='rangosFechaivaImpuesto'
            className='tw-rounded-md tw-mr-6'
            value={year.selectedYear}
            options={yearsOptionList}
            onChange={handleYearSelection}
          />
        </div>
        <TableERP
          columns={MODELO_115_COLUMNS(t, navigate, year.selectedYear)}
          className='tw-h-full'
          columnResizeMode='expand'
          value={data}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          size='small'
          loading={isLoading}
        />
      </div>
    </>
  )
}
